
import { Box, Container, Typography, Link, Grid, Divider, useTheme, TextField, Button, Snackbar } from '@mui/material';
import { GitHub, Twitter, LinkedIn, Send } from '@mui/icons-material';
import { useState } from 'react';

export default function Footer() {
  const theme = useTheme();
  const [email, setEmail] = useState('');
  const [snackbar, setSnackbar] = useState({ open: false, message: '' });
  
  const handleSubscribe = (e) => {
    e.preventDefault();
    // Simulate subscription
    setSnackbar({ open: true, message: 'Thanks for subscribing!' });
    setEmail('');
  };

  return (
    <Box 
      component="footer" 
      sx={{
        py: { xs: 3, md: 4 },
        px: 2,
        mt: 'auto',
        background: theme.palette.mode === 'dark' 
          ? 'linear-gradient(to right, #141e30, #243b55)'
          : 'linear-gradient(45deg, #2193b0, #6dd5ed)',
        color: 'white'
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              TimeBaba
            </Typography>
            <Typography variant="body2">
              Your ultimate time management companion for better productivity and focus.
            </Typography>
          </Grid>
          
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              Subscribe to Our Newsletter
            </Typography>
            <Box component="form" onSubmit={handleSubscribe} sx={{ 
              display: 'flex',
              gap: 1,
              flexDirection: { xs: 'column', sm: 'row' }
            }}>
              <TextField
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                size="small"
                sx={{
                  bgcolor: 'rgba(255,255,255,0.1)',
                  borderRadius: 1,
                  '& .MuiOutlinedInput-root': {
                    color: 'white',
                    '& fieldset': { borderColor: 'transparent' },
                    '&:hover fieldset': { borderColor: 'rgba(255,255,255,0.3)' },
                  }
                }}
              />
              <Button 
                type="submit"
                variant="contained"
                endIcon={<Send />}
                sx={{ 
                  bgcolor: 'rgba(255,255,255,0.2)',
                  '&:hover': { bgcolor: 'rgba(255,255,255,0.3)' }
                }}
              >
                Subscribe
              </Button>
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              Connect With Us
            </Typography>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Link href="#" color="inherit">
                <GitHub />
              </Link>
              <Link href="#" color="inherit">
                <Twitter />
              </Link>
              <Link href="#" color="inherit">
                <LinkedIn />
              </Link>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 3, borderColor: 'rgba(255, 255, 255, 0.1)' }} />
        
        <Typography variant="body2" align="center">
          © {new Date().getFullYear()} TimeBaba - All rights reserved
        </Typography>
      </Container>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        message={snackbar.message}
      />
    </Box>
  );
}
